// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9f26ae5d","77":"36312a40","115":"a66fb7a3","222":"5a73b301","280":"ea59d664","354":"b0616c38","444":"f9db5d39","510":"a0330be3","563":"11470ce7","567":"3f8d8d27","860":"5c1b3779","928":"f8a9c84c"}[chunkId] + ".chunk.js";
};